import type { ReactElement, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface SidebarProps {
  /** Conteúdo do topo (logo + workspace switcher) */
  header: ReactNode;
  /** Itens de navegação (SidebarNavSection + SidebarNavItem) */
  children: ReactNode;
  /** Conteúdo do rodapé (settings, user, ajuda) */
  footer?: ReactNode;
  className?: string;
}

export function Sidebar({ header, children, footer, className }: SidebarProps): ReactElement {
  return (
    <aside
      style={{
        background: 'oklch(0.2 0.026 273 / 0.6)',
        backdropFilter: 'var(--trakd-blur-glass)',
        WebkitBackdropFilter: 'var(--trakd-blur-glass)',
      }}
      className={cn(
        'border-border-subtle flex h-screen w-64 shrink-0 flex-col border-r',
        className,
      )}
    >
      <div className="border-color-violet/15 border-b px-5 py-4">{header}</div>
      <nav aria-label="Navegação principal" className="flex-1 overflow-y-auto px-3 py-4">
        {children}
      </nav>
      {footer ? <div className="border-border-subtle border-t px-3 py-4">{footer}</div> : null}
    </aside>
  );
}
